import './custom-color.css'
import 'swiper/swiper.min.css'

import * as c from '@chakra-ui/react'
import React from 'react'
import { ArrowIcon } from 'src/assets/icons/arrow.icon'
import SwiperCore, { Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react'

import PropertyMinimalCard from '../../cards/property/minimal'
import OldMinimalList from './old'

interface MinimalPropertiesList {
  properties?: any[]
  CustomCard?: any
  showMoreCard?: any
  CustomShowMoreCard?: any
  buttonColors?: { background: string; icon: string }
  black?: boolean
  redirectWithBlank?: boolean
  onClickCard?: (e?: any) => void
  slidesPerView?: number
  isOld?: boolean
  margin?: string
  sideButtons?: boolean
}

const MinimalCard = PropertyMinimalCard as any

const MinimalPropertiesList = ({
  properties = [],
  CustomCard,
  showMoreCard,
  CustomShowMoreCard,
  redirectWithBlank = true,
  onClickCard,
  slidesPerView,
  isOld = true,
  sideButtons = true,
  margin = '0px',
}: MinimalPropertiesList) => {
  SwiperCore.use([Navigation])

  const [isTablet, isDesktop] = c.useMediaQuery([
    '(max-width: 720px)',
    '(min-width: 1100px)',
  ])

  const slidesPerViewValue = isTablet ? 1.2 : isDesktop ? 4.2 : 3.3

  const prevRef = React.useRef(null)
  const nextRef = React.useRef(null)

  if (isOld)
    return (
      <OldMinimalList
        properties={properties}
        CustomCard={CustomCard}
        redirectWithBlank={redirectWithBlank}
        onClickCard={onClickCard}
      />
    )

  if (properties.length === 0) return null
  if (!properties) return null

  return (
    <c.Flex __css={{ '.clear-animations': {} }} zIndex={0} pos="relative">
      <Swiper
        slidesPerView={slidesPerView ?? slidesPerViewValue}
        spaceBetween={12}
        centerInsufficientSlides={false}
        centeredSlides={false}
        centeredSlidesBounds={false}
        className="clear-animations"
        style={{
          paddingBottom: 16,
          position: 'initial',
          margin: margin,
        }}
        onInit={(swiper: any) => {
          swiper.params.navigation.prevEl = prevRef.current
          swiper.params.navigation.nextEl = nextRef.current
          swiper.navigation.init()
          swiper.navigation.update()
        }}
      >
        {properties.map((p) => (
          <SwiperSlide key={p._id}>
            {CustomCard ? (
              <CustomCard
                {...p}
                onClick={() => onClickCard?.(p)}
                redirectWithBlank={redirectWithBlank}
                property={p}
              />
            ) : (
              <MinimalCard
                redirectWithBlank={redirectWithBlank}
                onClick={() => onClickCard?.(p)}
                property={p}
              />
            )}
          </SwiperSlide>
        ))}

        {showMoreCard && properties.slice(-1) && (
          <SwiperSlide>{CustomShowMoreCard}</SwiperSlide>
        )}

        {isDesktop && sideButtons && (
          <>
            <c.IconButton
              aria-label="prev button"
              bg="black.0"
              borderRadius="100%"
              shadow="lg"
              pos="absolute"
              left={-5}
              top="45%"
              bottom="50%"
              my="auto"
              zIndex="9"
              w="32px"
              h="32px"
              py="15px"
              icon={<ArrowIcon color="black" direction="left" height={12} />}
              ref={prevRef}
            />
            <c.IconButton
              aria-label="next button"
              bg="black.0"
              borderRadius="100%"
              pos="absolute"
              left="calc(100% - 20px)"
              my="auto"
              w="32px"
              h="32px"
              shadow="lg"
              top="45%"
              bottom="50%"
              zIndex="9"
              py="15px"
              icon={<ArrowIcon color="black" direction="right" height={12} />}
              ref={nextRef}
            />
          </>
        )}
      </Swiper>
    </c.Flex>
  )
}

export default MinimalPropertiesList
